import React, { useState, useEffect } from 'react';
import ImportsJournalTable from './ImportsJournalTable';
import PageTitle from '../common/PageTitle';
import { IMPORTS_PAGE_TABS } from '../../config';
import styled from '@emotion/styled';

import {
  fetchGetImportTasks,
  fetchGetImportTaskById,
  fetchGetFieldList,
} from '../../actions/imports';

import { IMPORT_SEARCH_FIELD_TYPES } from '../../config';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const ItemsTabsWrapper = styled('div')`
  .nav-tabs-orders {
    position: absolute;
    top: -38px;
  }

  .form-group {
    position: relative;
  }

  .nav-tabs-orders .nav-item.show .nav-link,
  .nav-tabs-orders .nav-link.active {
    color: #7e57c2;
    background-color: #fff;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
  }

  .nav-tabs-orders .nav-link-after {
    content: '';

    left: 0px;
    width: 100%;
    height: 5px;
    background-color: #fff;
    border: none;
  }

  .nav-tabs-orders .nav-link-after {
    border-top: 1px solid #edf0f2;

    margin-top: -1px;
  }

  .nav-tabs-orders .nav-link-after.active {
    border-top: 0px;
    margin-top: 0px;
  }

  .nav-tabs-orders .nav-link.active .badge {
    background-color: #7e57c2;
    color: #fff;
  }

  .nav-tabs-orders .nav-link .badge {
    background-color: #dfe4e6;
    color: #828489;
    margin-left: 10px;
    font-weight: 600;
  }

  .nav-tabs-orders .nav-link .badge {
  }

  .nav-tabs-orders .nav-item {
    margin-right: 4px;
  }

  .nav-tabs-orders .nav-link {
    border: 1px solid transparent;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
    background-color: #fbfcfd;
  }

  .nav-tabs-orders .nav-link.active {
    border: 1px solid transparent;
  }

  .nav-tabs-orders .nav-link:hover {
    background-color: #fff;
  }

  .nav-tabs-orders > li > a {
    color: #7a7c82;
    font-weight: 600;
  }

  .nav-link {
    display: block;
    padding: 0.5rem 1rem;
    cursor: pointer;
  }

  .nav-link .nav-link-icon {
    padding-top: 1px;
    margin-right: 3px;
  }

  .nav-link i {
    font-size: 1rem;
    margin-right: 3px;
    margin-top: 4px;
  }

  @media (max-width: 520px) {
    .nav-link {
      padding-right: 5px;
      padding-left: 5px;
      .badge {
        display: none;
      }
    }
  }
`;

const Imports = () => {
  const { t } = useAutoTranslation();

  const handleGetTaskData = (taskData) => [
    {
      label: t('Поиск'),
      value: (IMPORT_SEARCH_FIELD_TYPES.find((f) => f.value === taskData.searchField) || {}).label,
    },
    {
      label: t('Создавать и обновлять'),
      value: taskData.importMethod === 'CREATE' ? t('Да') : t('Нет'),
    },
    { label: t('Заменить изображения'), value: taskData.replacePictures ? t('Да') : t('Нет') },
    {
      label: t('Загружать остатки'),
      value: taskData.updateRests ? taskData.warehouseName : t('Нет'),
    },
    {
      label: t('Стирать значения, если они пустые'),
      value: taskData.clearEmptyValues ? t('Да') : t('Нет'),
    },
  ];

  const [activeTab, setActiveTab] = useState({ id: null });

  const location = useLocation();

  useEffect(() => {
    location.search === '?import-chz'
      ? setActiveTab({ id: 'chestny_znak', title: 'Честный знак' })
      : setActiveTab({ id: 'products', title: 'Товары' });
  }, [location.search]);

  const handleShowReport = (task) => task.itemsFailedCount;

  const PAGE_TITLE =
    activeTab.id === 'products' ? t('Импорт товаров') : t('Импорт пула номеров «Честный Знак»');

  return (
    <>
      {activeTab.id !== null ? (
        <>
          <PageTitle title={PAGE_TITLE} />
          <div className="row mt-5">
            <div className="col-12">
              <ItemsTabsWrapper>
                <ul className="nav nav-tabs-orders">
                  {IMPORTS_PAGE_TABS.map((tab) => (
                    <li className="nav-item" key={tab.id}>
                      <div
                        data-toggle="tab"
                        aria-expanded="true"
                        className={`nav-link ${activeTab.id === tab.id ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab)}
                      >
                        <div className="d-flex flex-row">
                          <div className="tab-title">{t(tab.title)}</div>
                        </div>
                      </div>
                      <div className={`nav-link-after ${activeTab === tab.id ? 'active' : ''}`} />
                    </li>
                  ))}
                </ul>
              </ItemsTabsWrapper>
            </div>
          </div>
          <ImportsJournalTable
            newTaskUrl="/imports-products/new"
            taskName={PAGE_TITLE}
            getTaskData={handleGetTaskData}
            getTasksAction={fetchGetImportTasks}
            getTaskDataAction={fetchGetImportTaskById}
            detailsTitle={t('Опции загрузки')}
            showReport={handleShowReport}
            reportUrl="/imports"
            activeTab={activeTab}
          />
        </>
      ) : null}
    </>
  );
};

export default Imports;
